"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.indexOf = void 0;
var lodash_1 = __importDefault(require("lodash"));
var indexOf = function indexOf(list, value) {
  var index = -1;
  if (lodash_1["default"].isArray(list) && list.length > 0) {
    list.some(function (item, itemIndex) {
      if (item && item.value === value) {
        index = itemIndex;
      }
      return index > -1;
    });
  }
  return index;
};
exports.indexOf = indexOf;